import { usePushEcommerceEvent } from './usePushEvent'

export function useSignUpEvent() {
    const push = usePushEcommerceEvent([], false)

    function pushSignUpEvent(method = 'Email') {
        push?.([
            { ecommerce: null },
            {
                event: 'sign_up',
                method: method,
            },
        ])
    }

    return pushSignUpEvent
}
